import React, { FC } from 'react'

import { ForeignProfileView } from 'components/page/ForeignProfile/ForeignProfileView'
import { useRedesignLayout } from 'hooks/useRedesign'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { chatMessengerReducer } from 'reducers/messenger/chatMessengerReducer'
import { promoServiceAvailableReducer } from 'reducers/promoServiceAvailable/promoServiceAvailableReducer'

import { ForeignProfileNext } from './ForeignProfileNext'
import { GQLForeignRootQuery } from './gql/__generated__/ForeignRoot'

export const ForeignSwitch: FC<{ data: GQLForeignRootQuery }> = ({ data }) => {
  useReducersInsert({
    promoServiceAvailable: promoServiceAvailableReducer,
    chatMessengerReducer,
  })

  const redesignLayout = useRedesignLayout()

  if (redesignLayout) {
    return <ForeignProfileNext data={data} />
  }

  return <ForeignProfileView data={data} />
}
